import { styled } from '@material-ui/core/styles';

export const LoaderContainer = styled('div')({
  alignItems: 'center',
  display: 'flex',
  height: '100%',
  justifyContent: 'center'
});
